'use client';
// This is hacky component to avoid google warnings about duplicated script tags
// Basically if we use native script tag, it will be duplicated because of https://github.com/vercel/next.js/discussions/42170
// If we use NextScript, it will not be duplicated, but it will be cache between client routes,
// so duplicated after you navigate around.
// This scoped script will resolve this issues.

import NextScript from 'next/script';
import {
  DetailedHTMLProps,
  ScriptHTMLAttributes,
  useLayoutEffect,
} from 'react';

export const ScopedScript = ({
  id,
  type,
  dangerouslySetInnerHTML,
}: DetailedHTMLProps<
  ScriptHTMLAttributes<HTMLScriptElement>,
  HTMLScriptElement
>) => {
  useLayoutEffect(
    () => () => {
      document.getElementById(id || '')?.remove();
    },
    [id]
  );

  return (
    <NextScript
      id={id}
      type={type}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      suppressHydrationWarning={true}
      strategy="beforeInteractive"
    />
  );
};
